import 'aos/dist/aos.css'

import AOS from 'aos'

export default () => {
  AOS.init({
    // delay: 80,
    delay: 100,
    duration: 1000,
    // ease: 'east-in-out',
    ease: 'ease',
    once: true
  });
}
